import React from 'react';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import Images from '../Images';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Vac() {

    return (

        <div>
            <div>
                <Header />
                <div className='inner_page'>
                    <Container className='mt-4'>
                        <Row className='align-items-center justify-content-between pt-5 pb-5'>
                        <Col md={6} lg={6} xl={5} xxl={6}>
                        <p className='vactitle mb-0'>Welcome to</p>
                        <h1 className='vacmain fw-600'>EdaFace VAC</h1>
                        <p className='vacpara'>VAC Refers To The Verification Asset Centre. It is a Unique Component of EdaFace and the First of Its Kind in The Global Crypto Market.</p>
                      <Link to="/vac-verification"><button className='themebtn themehoverbtn rounded-1 mt-1 py-2 px-4 fw-600'> Start Verification</button></Link>
                        </Col>
                        <Col md={6} lg={6} xl={5} xxl={5} className='mt-4 mt-md-0'>
                        <img src={Images.vac1} className='img-fluid' alt='vac'/>
                        </Col>
                        </Row>
                        <div className='text-center mt-3'>
                        <p className='vactitle mb-0'>Edaface</p>
                        <h1 className='mainvac fw-600'>Functions of VAC</h1>
                        <p className='vacpara'>EdaFace VAC Performs Two Functions</p>
                        </div>
                        <Row className='align-items-center justify-content-between pt-3 pb-5'>
                        <Col md={6} lg={6} xl={5} xxl={5}>
                        <img src={Images.vac2} className='img-fluid' alt='vac'/>
                        </Col>
                        <Col md={6} lg={6} xl={5} xxl={6}>
                        <p className='vactitle mb-0'>EdaFace </p>
                        <h1 className='vacmain fw-600'>VAC Verifies Scam</h1>
                        <p className='vacpara'>EdaFace VAC enables you to identify scams in the Crypto Market, especially
                        rug pull scams, making it the first of its kind in the crypto industry.<br></br>
                        VAC Gives up to 98% Accuracy in Scam Detection.<br></br>
                        Today, You Can Navigate The Crypto World With Confidence!
                        </p>
                        </Col>                     
                        </Row>
                        <Row className='align-items-center justify-content-between pt-5 pb-5'>
                        <Col md={6} lg={6} xl={5} xxl={6}>
                        <p className='vactitle mb-0'>EdaFace</p>
                        <h1 className='vacmain fw-600'>VAC Verifies Profitability</h1>
                        <p className='vacpara'>Not Only Does It Identify Scams, EdaFace VAC Also Helps Ascertain A Digital
                        Asset's Profitability.<br></br>
                        You Can Predict The Profitability of a Crypto Project Via VAC.
                        </p>
                        <button className='themebtn themehoverbtn rounded-1 mt-1 py-2 px-4 fw-600'> About VAC</button>

                        </Col>
                        <Col md={6} lg={6} xl={5} xxl={5} className='mt-4 mt-md-0'>
                        <img src={Images.vac3} className='img-fluid' alt='vac'/>
                        </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Vac